<template>
    <div >
        <!-- <Teleport to="body"> -->
            <!-- <Transition name="modal-fade"> -->
                <base-controller-modal v-for="(modal, index) in modals" :key="index"
                    :z_index="1000 + index"
                    :persistente="!!modal.persistente"
                    @close="closeModal()"
                    >
                    <component 
                        :is="modal.component" 
                        v-bind="modal.props"
                        v-on="modal.events"
                        @close="closeModal()"
                        />
                </base-controller-modal>
        <!-- </Teleport> -->
    </div>
</template>

<script>
    import SeguroModal from './SeguroModal.vue';
    import PruebaModal from '../PruebaModal.vue';
    import BaseModal from '../BaseModal.vue';
    import TableModal from './TableModal.vue';
    import BaseControllerModal from './BaseControllerModal.vue';
    import FormModal from './FormModal.vue';
    import Buscador from '@/components/layout/Buscador.vue';
    import BuscadorModal from './BuscadorModal.vue';
    import DiasSelectModal from './DiasSelectModal.vue';
    import DialogoAccionAcceso from '@/components/Accesos/DialogoAccionAcceso.vue';

    export default {
        components: {
            BaseModal,
            SeguroModal,
            PruebaModal,
            TableModal,
            FormModal,
            BaseControllerModal,
            BuscadorModal,
            Buscador,
            DiasSelectModal,
            DialogoAccionAcceso,
            // Asíncronos: ModalController vive en App.vue y el de impresión
            // arrastra pdfmake y las fuentes del certificado; así solo se
            // descargan cuando alguien abre uno de estos diálogos.
            DialogoCongreso: () => import('@/components/Congresos/DialogoCongreso.vue'),
            DialogoImprimirCertificados: () => import('@/components/Congresos/DialogoImprimirCertificados.vue'),
            DialogoRevisarFactores: () => import('@/components/Economico/FactoresCredito/DialogoRevisarFactores.vue'),
            DialogoHistorialFactores: () => import('@/components/Economico/FactoresCredito/DialogoHistorialFactores.vue'),
            DialogoRevisarCostos: () => import('@/components/Economico/FactoresCredito/DialogoRevisarCostos.vue'),
            DialogoHistorialCostos: () => import('@/components/Economico/FactoresCredito/DialogoHistorialCostos.vue'),
            DialogoElegirCarreras: () => import('@/components/Economico/FactoresCredito/DialogoElegirCarreras.vue'),
            DialogoItem: () => import('@/components/Economico/CatalogoItems/DialogoItem.vue'),
            DialogoHistorialItem: () => import('@/components/Economico/CatalogoItems/DialogoHistorialItem.vue'),
            DialogoPlanEconomico: () => import('@/components/Economico/CatalogoItems/DialogoPlanEconomico.vue'),
            DialogoHistorialPlanEconomico: () => import('@/components/Economico/CatalogoItems/DialogoHistorialPlanEconomico.vue'),
            DialogoElegirPlanEconomico: () => import('@/components/Economico/CatalogoItems/DialogoElegirPlanEconomico.vue'),
            DialogoGrupoOferta: () => import('@/components/Economico/CatalogoItems/DialogoGrupoOferta.vue'),
            DialogoAsignarFilas: () => import('@/components/Economico/CatalogoItems/DialogoAsignarFilas.vue'),
            DialogoMoverFilas: () => import('@/components/Economico/CatalogoItems/DialogoMoverFilas.vue'),
            DialogoHistorialOferta: () => import('@/components/Economico/CatalogoItems/DialogoHistorialOferta.vue'),
            DialogoAgregarItemsPlan: () => import('@/components/Economico/CatalogoItems/DialogoAgregarItemsPlan.vue'),
            DialogoHistorialItemsPlan: () => import('@/components/Economico/CatalogoItems/DialogoHistorialItemsPlan.vue'),
            DialogoDisparadoresCobro: () => import('@/components/Economico/CatalogoItems/DialogoDisparadoresCobro.vue'),
            DialogoEventoCobro: () => import('@/components/Economico/CatalogoItems/DialogoEventoCobro.vue'),
            DialogoHistorialEventoCobro: () => import('@/components/Economico/CatalogoItems/DialogoHistorialEventoCobro.vue'),
            DialogoReglaCobro: () => import('@/components/Economico/CatalogoItems/DialogoReglaCobro.vue'),
            DialogoReglaCobroCatalogo: () => import('@/components/Economico/CatalogoItems/DialogoReglaCobroCatalogo.vue'),
            DialogoCalendariosPlazos: () => import('@/components/Economico/CatalogoItems/DialogoCalendariosPlazos.vue'),
            DialogoCalendarioGrupo: () => import('@/components/Economico/CatalogoItems/DialogoCalendarioGrupo.vue'),
            DialogoCopiarTarifas: () => import('@/components/Economico/CatalogoItems/DialogoCopiarTarifas.vue'),
            DialogoHistorialTarifas: () => import('@/components/Economico/CatalogoItems/DialogoHistorialTarifas.vue'),
        },
        computed: {
            modals() {
                return this.$store.getters.modals;
            },
            topModal() {
                const modals = this.$store.getters.modals;
                return modals.length ? modals[modals.length - 1] : null;
            },

        },
        methods: {
            closeModal() {
                this.$store.dispatch('closeTopModal');
            },
        }
        
    }
</script>